import { BookingConfirmationContent } from '@components/Confirmation/BookingConfirmationContent';
import { FleetPromoCard } from '@components/Confirmation/FleetPromoCard';
import type { BookingRecordDetailsCustomer } from '@navio/nsdk';
import { type ReactNode } from 'react';

/** Confirmed-booking body. The page owns the fetch, the heading, and the not-yet-paid guard. */
export const BookingConfirmation = ({
  bookingDetails,
  heading
}: {
  bookingDetails: BookingRecordDetailsCustomer;
  heading: ReactNode;
}) => (
  <div className='flex w-full flex-col gap-4'>
    <BookingConfirmationContent bookingDetails={bookingDetails} heading={heading} />
    {/* Fleet view is only worth promoting once the customer has an actual booking with us. */}
    <FleetPromoCard />
  </div>
);
